
import { ApiPlugin } from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import { APISetting } from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import { Device } from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";
import { APITranslations } from "@nolimitcity/slot-launcher/bin/interfaces/APITranslations";

export class SlotApiAdapter {

    protected readonly _slotApi: ApiPlugin;

    constructor(api: ApiPlugin) {
        this._slotApi = api;
    }

    public addTranslations(translations: APITranslations): void {
        this._slotApi.translations.add(translations);
    }

    public translate(text: string): string {
        return this._slotApi.translations.translate(text);
    }

    public formatCurrency(amount: number, options: any): string {
        return this._slotApi.currency.format(amount, options);
    }

    public formatCurrencyValue(amount: number, options: any): string {
        return this._slotApi.currency.formatValue(amount, options);
    }

    public get hideCurrency(): boolean {
        return this._slotApi.options.hideCurrency;
    }

    public isFastSpin(): boolean {
        return this.getSettings(APISetting.FAST_SPIN);
    }

    public isSoundLoopOn(): boolean {
        return this.getSettings(APISetting.MUSIC);
    }

    public isSoundEffectsOn(): boolean {
        return this.getSettings(APISetting.SFX);
    }

    private getSettings(name: APISetting): boolean {
        return this._slotApi.settings.get(name);
    }

    public getDevice(): Device {
        return this._slotApi.options.device;
    }

    public getQuality(): string {
        return this._slotApi.options.quality;
    }

    public getSmartLoading(): boolean {
        return this._slotApi.options.smartLoading!;
    }

    public getReplayMode(): boolean {
        return this._slotApi.options.replay != undefined;
    }

    public isLeftHanded(): boolean {
        return this.getSettings(APISetting.LEFT_HAND_MODE);
    }
}